/* eslint-disable*/
import React from "react";

const BotSenseChat = () => {
  return (
    <div className="mt-4" style={{ height: "100vh", width: "100%", padding: 0, margin: 0 }}>
      <iframe
        src="https://app.botsense.chat/products/crmv2/chat"
        title="Botsense Chat"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      ></iframe>
    </div>
  );
};

export default BotSenseChat;
